export function PlusSign(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 26 26'
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        d='M13.795.5v25M25.927 13.597h-25'
      />
    </svg>
  );
}
